import VoteModal from './VoteModal';
import VoteModalContainer from './VoteModalContainer';

export {VoteModalContainer};
export default VoteModal;
